import { useTranslation } from 'react-i18next';
import { Box, Group, Stack, Text } from '@mantine/core';
import { IconTruck } from '@tabler/icons-react';
import DocRow from '@/components/app/deals/steps/forwarding/DocRow';
import { collectVehicleDocs } from '@/lib/forwardingView';
import { fmtFwdDate } from '@/lib/forwarding';
import type { BargainStepsInfo } from '@/types/deals';

interface DealVehicleDocsProps {
  readonly info: BargainStepsInfo;
}

// Секция «По машинам» вкладки «Документы»: по каждой машине — ТТН/ТРН (и пр. документы ТС) со
// скачиванием. УПД здесь нет (он в «Подпись УПД»), документы уровня дня — в «Документы по дням».
export default function DealVehicleDocs({ info }: DealVehicleDocsProps) {
  const { t } = useTranslation();
  const vehicles = collectVehicleDocs(info);

  return (
    <Stack gap="md">
      <Text fz="sm" fw={600} c="gray.8">
        {t('app.deals.forwarding.byVehiclesTitle')}
      </Text>
      {vehicles.length === 0 ? (
        <Text fz="sm" c="gray.6">
          {t('app.deals.forwarding.byVehiclesEmpty')}
        </Text>
      ) : (
        vehicles.map((v, i) => (
          <Stack key={`${v.ttnId ?? v.regnum}-${i}`} gap="xs">
            <Group gap="xs" wrap="nowrap">
              <IconTruck size={15} style={{ color: 'var(--mantine-color-gray-6)', flexShrink: 0 }} />
              <Text fz="sm" fw={500}>
                {v.regnum}
              </Text>
              {v.date ? (
                <Text fz="xs" c="gray.6">
                  {fmtFwdDate(v.date)}
                </Text>
              ) : null}
            </Group>
            <Box pl="sm">
              <Stack gap="xs">
                {v.docs.map((doc, di) => (
                  <DocRow key={doc.id ?? `${i}-${di}`} doc={doc} />
                ))}
              </Stack>
            </Box>
          </Stack>
        ))
      )}
    </Stack>
  );
}
